import moment from 'moment';
import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';
import { OnlyFansAllCounters } from './useMetricsDailyStats';

export interface SubscriberMetricsCountersAllGroupByDay {
    _id: {
        year: number;
        month: number;
        day: number;
    };
    counters: OnlyFansAllCounters;
}

const useSextforceMetricsAccountFansCountersAll = (startDate: Date, endDate: Date, timezone: string) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const params = useParams();
    const axios = useAxios();

    // Fetch Fans Counters
    const fetchAccountFansCountersAll = async (
        startDate: Date,
        endDate: Date,
        timezone: string,
    ): Promise<SubscriberMetricsCountersAllGroupByDay[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${params.userId}/fanscounters/all?${new URLSearchParams({
            startDate: moment(startDate).tz(timezone, true).toISOString(),
            endDate: moment(endDate).tz(timezone, true).toISOString(),
            timezone: timezone,
        })}`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                console.error(error);
                handleHttpError(error, dialog);

                return [];
            });

        return data;
    };

    return useQuery(
        ['metricsFansCountersAll', userContext.jwtToken, params.userId, startDate, endDate, timezone],
        () => fetchAccountFansCountersAll(startDate, endDate, timezone),
        {
            refetchOnWindowFocus: false,
            staleTime: 60 * 1000 * 60 * 12,
            enabled: userContext.jwtToken && settingsContext.apiKey && params.userId ? true : false,
        },
    );
};

export default useSextforceMetricsAccountFansCountersAll;
